export default __webpack_public_path__ + "static/media/emailNew.cc865295.svg";